import { useToast } from "../../../hook/usetoast";
import { useEffect, useState } from "react";

import { useDisconnect, useAppKit, useAppKitAccount } from '@reown/appkit/react'

import { useBeforeconnect, useConnectWallet, useGetAirDropTimer, useMetamaskDisconnect } from "../../../views/home/api/api";
import {

    NavbarText,
    Modal,
    ModalHeader,
    ModalBody,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,

} from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useModalContext } from '../../../contexts/ModalContext';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { ActionButtonList } from "../../../views/Wallectconnect/ActionButtonList";
import Loader from "../../../views/Loader/buttonLoad";

const ConnectWalletButton = () => {

    const schema = yup.object().shape({
        referUserId: yup.string()
            .required('ReferUserId is Required'),
        referralCode: yup.string()
            .required('Referral Code is Required'),

    })

    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            referralCode: "",
            referUserId: ""

        }
    });
    const navigate = useNavigate()
    const { id } = useParams()
    const { open, close } = useAppKit()

    const [before, setBefore] = useState('')
    const { isConnected, address } = useAppKitAccount();

    const { disconnect } = useDisconnect();



    const toast = useToast()
    const { isloadingconnect, setIsloadingconnect, userDetails, setUserDetails, modalConnectWallet, setModalConnectWallet, isOpenMenu, setIsOpenMenu, referralCode, setReferralCode } = useModalContext()

    const userData = useGetAirDropTimer()

    useEffect(() => {
        if (address) {
            getProfile()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionStorage.getItem('user_JWT')])
    useEffect(() => {
        if (id) {
            reset({ referralCode: id, referUserId: before });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, before])
    const getProfile = async () => {
        if (sessionStorage.getItem('user_JWT')) {
            const res = await userData.mutateAsync()
            setUserDetails(res)
        }
    }

    const isReadyForConnection = isConnected && !isloadingconnect && sessionStorage.getItem('role') !== 'adminView';

    const [shouldLogin, setShouldLogin] = useState(false);



    const closeBtn = <button className="close" onClick={() => setModalConnectWallet(false)}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3359 10.5L16.5547 14.7188C16.7891 14.9531 16.7891 15.3828 16.5547 15.6172L15.5781 16.5938C15.3438 16.8281 14.9141 16.8281 14.6797 16.5938L10.5 12.375L6.28125 16.5938C6.04688 16.8281 5.61719 16.8281 5.38281 16.5938L4.40625 15.6172C4.17188 15.3828 4.17188 14.9531 4.40625 14.7188L8.625 10.5L4.40625 6.32031C4.17188 6.08594 4.17188 5.65625 4.40625 5.42188L5.38281 4.44531C5.61719 4.21094 6.04688 4.21094 6.28125 4.44531L10.5 8.66406L14.6797 4.44531C14.9141 4.21094 15.3438 4.21094 15.5781 4.44531L16.5547 5.42188C16.7891 5.65625 16.7891 6.08594 16.5547 6.32031L12.3359 10.5Z" fill="#6E737E" />
        </svg>
    </button>;











    const userConnectWallet = useConnectWallet()
    const userDisconnect = useMetamaskDisconnect()
    const beforeConnect = useBeforeconnect()

    useEffect(() => {

        if (isConnected && !sessionStorage.getItem("user_JWT")) {

            checkLogin()
        }
        const storedReferralId = localStorage.getItem('memberId');
        if (storedReferralId) {
            setBefore(storedReferralId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isConnected])

    const checkLogin = async () => {
        try {
            setIsloadingconnect(true)
            let res = await beforeConnect.mutateAsync({ address: address })

            if (!res?.status) {
                setReferralCode(true)
                setIsloadingconnect(false)

            } else {
                setIsloadingconnect(false)
            }

        } catch (error) {

        }
    }
    const hideBrandingOnce = () => {

        const modal = document.querySelector('w3m-modal');
        if (!modal?.shadowRoot) return false;

        const router = modal.shadowRoot
            ?.querySelector('w3m-router');
        const connectView = router?.shadowRoot
            ?.querySelector('w3m-connect-view');
        const legalFooter = connectView?.shadowRoot
            ?.querySelector('w3m-legal-footer');

        const uxByReown = legalFooter?.shadowRoot
            ?.querySelector('wui-ux-by-reown');
        let brandingHidden = false;

        if (uxByReown) {
            uxByReown.style.setProperty('display', 'none', 'important');
            brandingHidden = true;
        }


        return brandingHidden
    };

    const handleConnect = async () => {
        try {
            setModalConnectWallet(false);
            await open();

            let tries = 0;
            const maxTries = 10;
            const id = setInterval(() => {
                if (hideBrandingOnce() || tries >= maxTries) {
                    clearInterval(id);
                }
                tries += 1;
            }, 100);

            setIsOpenMenu(false);
            setShouldLogin(true);
        } catch (error) {
            close();

            const message =
                typeof error === 'string'
                    ? error
                    : error?.message || 'Unknown error occurred';

            if (message === 'Proposal expired') {
                return;
            }

        }
    };

    useEffect(() => {
        if (shouldLogin && isConnected && address) {
            getLogindetails(isConnected, address);
            setShouldLogin(false); // avoid calling multiple times
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldLogin, isConnected, address]);







    const getLogindetails = async (name, address = '') => {

        setIsloadingconnect(true)

        let obj = {
            address: address?.toLowerCase(),
            referralCode: id
        }
        let res = await beforeConnect.mutateAsync(obj)


        if (res?.status) {
            setIsloadingconnect(true)
            setModalConnectWallet(false)

            let res = await userConnectWallet.mutateAsync({ address: address, refferCode: id || '', referUserId: '' })
            if (res?.status) {
                setIsloadingconnect(true)
                setReferralCode(false)
                setTimeout(async () => {
                    setIsloadingconnect(true)
                    const userRes = await userData.mutateAsync()
                    setUserDetails(userRes)
                    if (userRes?.status) {
                        if (userRes.data.commissionDistributeStatus && userRes.data.isEmailVerified) {
                            navigate('/dashboard');
                        } else if (userRes.data.commissionDistributeStatus && !userRes.data.isEmailVerified) {
                            navigate('/profile-details');
                        } else if (!userRes.data.commissionDistributeStatus && !userRes.data.isEmailVerified) {
                            navigate('/airdrop-deposit');
                        }
                        setIsOpenMenu(!isOpenMenu)
                        setIsloadingconnect(false)

                    }


                }, 2000);
                sessionStorage.setItem('connectAddress', address?.toLowerCase())
                sessionStorage.setItem('user_JWT', res?.token)
                localStorage.setItem("account", address?.toLowerCase());
                setModalConnectWallet(false)
            } else {
                setIsloadingconnect(false)
                await disconnect();
                localStorage.removeItem("account")
                sessionStorage.removeItem('user_JWT')
            }

        }
        else if (!res?.status) {
            if (res?.referralUserId) {
                setBefore(res?.referralUserId)
                localStorage.setItem('memberId', res.referralUserId);
            }
            if (res?.message === 'Invalid referral code') {
                toast.error(res?.message)
                reset({ referralCode: '', referUserId: '' })
                localStorage.removeItem('memberId');
                setBefore('')
                await disconnect();
                setIsloadingconnect(false)
                localStorage.removeItem("account")
                sessionStorage.removeItem('user_JWT')
                navigate('/')
                return
            }

            sessionStorage.setItem('connectAddress', address?.toLowerCase())
            localStorage.setItem("account", address?.toLowerCase());
            setIsloadingconnect(false)
            setModalConnectWallet(false)
            setReferralCode(true)


        }
        else {
            toast.error(res?.message)
            reset({ referralCode: '', referUserId: '' })
            setBefore('')
            await disconnect();
            localStorage.removeItem('memberId');
            setIsloadingconnect(false)
            localStorage.removeItem("account")
            sessionStorage.removeItem('user_JWT')
            navigate('/')
        }
    }



    const disconnectWallet = async () => {
        setIsloadingconnect(true)
        setReferralCode(false)

        const res = await userDisconnect.mutateAsync({ address: address?.toLowerCase() })
        if (res?.status) {
            disconnect();
            localStorage.removeItem("account")
            localStorage.removeItem('memberId');
            sessionStorage.removeItem('user_JWT')
            sessionStorage.removeItem('connectAddress')
            localStorage.removeItem('hasSeenFestivalOffer')
            reset({ referralCode: '', referUserId: '' })
            localStorage.clear()
            sessionStorage.clear()

            navigate('/')
            toast.error("Wallet disconnected successfully");
            await disconnect()
            setIsloadingconnect(false)
            setIsOpenMenu(!isOpenMenu)
            setReferralCode(false)

        }

    };

    const onSubmit = async (data) => {

        try {
            setIsloadingconnect(true)
            let resData = {
                address: address,
                refferCode: data?.referralCode,
                referUserId: data?.referUserId
            }
            let res = await userConnectWallet.mutateAsync(resData)
            if (res?.status) {
                reset()
                localStorage.removeItem('memberId');
                setReferralCode(false)
                sessionStorage.setItem('user_JWT', res?.token)
                setReferralCode(!referralCode)
                setTimeout(async () => {
                    setIsloadingconnect(true)
                    const userRes = await userData.mutateAsync()
                    setUserDetails(userRes)
                    if (userRes?.status) {
                        if (userRes.data.commissionDistributeStatus && userRes.data.isEmailVerified) {
                            navigate('/dashboard');
                        } else if (userRes.data.commissionDistributeStatus && !userRes.data.isEmailVerified) {
                            navigate('/profile-details');
                        } else if (!userRes.data.commissionDistributeStatus && !userRes.data.isEmailVerified) {
                            navigate('/airdrop-deposit');
                        }
                        setIsloadingconnect(false)
                        setIsOpenMenu(!isOpenMenu)

                    }


                }, 2000);

            } else {
                setIsloadingconnect(false)
                await disconnect();
                localStorage.removeItem("account")
                reset({ referralCode: '', referUserId: '' })
                setBefore('')
                localStorage.removeItem('memberId');
                sessionStorage.removeItem('user_JWT')
            }

        } catch (error) {
            setIsloadingconnect(false)

        }
    }

    const adminViewAddress = sessionStorage.getItem('address')
    const adminrole = sessionStorage.getItem('role')


    return (
        <div>
            {userConnectWallet?.isLoading && <Loader />}
            {
                adminrole === 'adminView' ?
                    <div>
                        <NavbarText className={`${adminrole !== 'adminView' ? 'd-none' : 'd-inline-flex navbar-text flex-wrap g-10'}`}>

                            <UncontrolledButtonDropdown>
                                <DropdownToggle className='btn btnEmpty metamaskId'>
                                    <span className='d-flex g-8 align-items-center'>
                                        <img src={require('../../../assets/images/metamaskId-img.png')} alt='metamaskId-img.png' />
                                        <span>{adminViewAddress?.slice(0, 6)}....{adminViewAddress?.slice(-5)}</span>
                                    </span>
                                    <i className='bi bi-chevron-down'></i>
                                </DropdownToggle>

                            </UncontrolledButtonDropdown>

                        </NavbarText>


                    </div> :
                    isReadyForConnection ?
                        <div>
                            <NavbarText className={`${!isConnected ? 'd-none' : 'd-inline-flex navbar-text flex-wrap g-10'}`}>

                                <UncontrolledButtonDropdown>
                                    <DropdownToggle className='btn btnEmpty metamaskId'>
                                        <span className='d-flex g-8 align-items-center'>
                                            <img src={require('../../../assets/images/metamaskId-img.png')} alt='metamaskId-img.png' />
                                            <span>{address?.slice(0, 6)}....{address?.slice(-5)}</span>
                                        </span>
                                        <i className='bi bi-chevron-down'></i>
                                    </DropdownToggle>
                                    {
                                        userDetails?.data?.isEmailVerified ?
                                            <DropdownMenu right className='userDropdownMenu'>
                                                <DropdownItem onClick={(e) => {
                                                    e.preventDefault(); // Prevent routing
                                                    if (userDetails?.data?.commissionDistributeStatus && !userDetails?.data?.isEmailVerified) {
                                                        navigate('profile-details')
                                                    } else if (!userDetails?.data?.commissionDistributeStatus) {
                                                        e.preventDefault();
                                                        toast.error('Need to deposit to access the profile.');
                                                    } else {
                                                        navigate('profile')
                                                    }

                                                }}>
                                                    <span className="iconCircle">
                                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1.55556 6.80469C1.55556 7.49413 1.69135 8.17682 1.95519 8.81378C2.21903 9.45073 2.60574 10.0295 3.09325 10.517C3.58075 11.0045 4.15951 11.3912 4.79647 11.6551C5.43343 11.9189 6.11612 12.0547 6.80556 12.0547C7.495 12.0547 8.17769 11.9189 8.81465 11.6551C9.4516 11.3912 10.0304 11.0045 10.5179 10.517C11.0054 10.0295 11.3921 9.45073 11.6559 8.81378C11.9198 8.17682 12.0556 7.49413 12.0556 6.80469C12.0556 6.11525 11.9198 5.43256 11.6559 4.7956C11.3921 4.15864 11.0054 3.57988 10.5179 3.09238C10.0304 2.60487 9.4516 2.21816 8.81465 1.95432C8.17769 1.69048 7.495 1.55469 6.80556 1.55469C6.11612 1.55469 5.43343 1.69048 4.79647 1.95432C4.15951 2.21816 3.58075 2.60487 3.09325 3.09238C2.60574 3.57988 2.21903 4.15864 1.95519 4.7956C1.69135 5.43256 1.55556 6.11525 1.55556 6.80469Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M5.05556 5.63867C5.05556 6.1028 5.23993 6.54792 5.56812 6.87611C5.89631 7.2043 6.34143 7.38867 6.80556 7.38867C7.26969 7.38867 7.71481 7.2043 8.04299 6.87611C8.37118 6.54792 8.55556 6.1028 8.55556 5.63867C8.55556 5.17454 8.37118 4.72942 8.04299 4.40124C7.71481 4.07305 7.26969 3.88867 6.80556 3.88867C6.34143 3.88867 5.89631 4.07305 5.56812 4.40124C5.23993 4.72942 5.05556 5.17454 5.05556 5.63867Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M3.40356 10.8006C3.54794 10.3201 3.84337 9.89886 4.24603 9.59949C4.6487 9.30012 5.13713 9.13852 5.63889 9.13867H7.97222C8.47462 9.1385 8.96366 9.30049 9.36662 9.60055C9.76957 9.90061 10.0649 10.3227 10.2087 10.8041" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                    <span>Profile</span>
                                                </DropdownItem>
                                            </DropdownMenu> : ""
                                    }

                                </UncontrolledButtonDropdown>
                                <ActionButtonList />

                            </NavbarText>

                            <Modal isOpen={referralCode} centered="true" className="mymodal" backdropClassName="modalbackbg" >
                                <ModalHeader style={{ textAlign: "center" }} >Enter Referrer Details</ModalHeader>
                                <ModalBody>
                                    <div>
                                        <div>
                                            <div className="referral">
                                                <form onSubmit={handleSubmit(onSubmit)}>

                                                    <div className='form-group formInputs'>
                                                        <label htmlFor="id">Member ID</label>
                                                        <Controller
                                                            name="referUserId"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    {...field}
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="regId1"
                                                                    disabled={before !== ''}
                                                                    placeholder="Enter Your Referral UserId"
                                                                    autoComplete="off" />
                                                            )} />
                                                        {errors.referUserId && <p className="errMsg">* {errors.referUserId.message}</p>}

                                                    </div>
                                                    <div className='form-group formInputs'>
                                                        <label htmlFor="code">Referral Code</label>
                                                        <Controller
                                                            name="referralCode"
                                                            control={control}
                                                            render={({ field }) => (
                                                                <input
                                                                    {...field}
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="regId1"
                                                                    placeholder="Enter Your Referral Code"
                                                                    autoComplete="off"
                                                                    disabled={id}
                                                                />
                                                            )} />
                                                        {errors.referralCode && <p className="errMsg">* {errors.referralCode.message}</p>}

                                                    </div>


                                                    <div className='text-center'>
                                                        <div className='mt-4 mb-3'>
                                                            <button className='btn btn-primary fs-18 fw-600 px-4 px-lg-5' >Submit</button>
                                                        </div>
                                                    </div>

                                                </form>
                                                <div className='text-center'>
                                                    <div className='mt-4 mb-3'>
                                                        <button className='btn btn-primary fs-18 fw-600 px-4 px-lg-5' onClick={() => disconnectWallet()}>Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </ModalBody>
                            </Modal>
                        </div>
                        :

                        <div>


                            <NavbarText className={isConnected ? 'd-none' : ''}>
                                <button className="btn btn-primary btnheader ml-2"
                                    onClick={(e) => handleConnect()}>
                                    <span className="px-0">Connect Wallet</span>
                                </button>

                            </NavbarText>


                            <Modal isOpen={modalConnectWallet} centered="true" className="mymodal connectwalletmodal" backdropClassName="modalbackbg">
                                <ModalHeader toggle={() => setModalConnectWallet(!modalConnectWallet)} close={closeBtn}>Connect Wallet</ModalHeader>
                                <ModalBody className='pt-1 px-3 pb-4'>
                                    <div className='cntwalletTxt text-center'>Start Exploring THE PILL Connecting Wallet</div>
                                    <div className="text-center mb-3">
                                        <button className='btn metamaskLink' onClick={(e) => handleConnect()}>

                                            <span className="px-0">Connect Wallet</span>
                                            <span className='circlearrow def-ml-14'>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="8" cy="8" r="8" fill="#FCD535" />
                                                    <g>
                                                        <path d="M11.8889 8H4.11114" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M11.8889 8L9.66669 10.2222" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M11.8889 7.99999L9.66669 5.77777" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                                    </g>
                                                </svg>
                                            </span>
                                        </button>
                                    </div>

                                </ModalBody>
                            </Modal>

                        </div>
            }
        </div>
    )

}
export default ConnectWalletButton;